import React from "react";
import StoreFocus from "../../focus/StoreFocus";
import {
    FOCUS_LAYER_DEFAULT_FOCUS,
} from "../../common/const";
import focusable from "../../focus/Focusable";
import StoreSounds from "../../store/StoreSounds";
import StoreApp from "../../store/StoreApp";
import StoreGameTimeLimitsPopup from "../../store/StoreGameTimeLimitsPopup";

const CloseBtn = focusable(class CloseBtn extends React.Component {


    onCLick = () => {
        StoreSounds.playPls('click');

        if(!StoreApp.clicksEnabled)    return;

        StoreGameTimeLimitsPopup.hide();
        StoreFocus.setCurrentFocusLayer(null, FOCUS_LAYER_DEFAULT_FOCUS.SAVED);
    }

    render() {
        //console.log('render CloseBtn');

        return (
            <div className={"btn focusable close " + (this.props.focused ? " focused" : "")} onClick={this.onCLick}></div>
        );

    }
})

export default CloseBtn;
